'use strict';function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}(function initArticleFilter() {
  var elArticleFilterForm = document.querySelector('[data-js="js-article-filter-form"]');
  var elArticleSearchForm = document.querySelector('[data-js="js-article-search-form"]');
  var elArticleSearchInput = document.querySelector('[data-js="js-article-search-input"]');
  var arrFilterCheckboxes = elArticleFilterForm && Array.prototype.slice.call(elArticleFilterForm.querySelectorAll('input[type="checkbox"]'));

  var baseUrl = window.location.href.split('?')[0];
  var urlDelimiter = ',';

  var params = new URLSearchParams(window.location.search);
  var objUrlParams = {};

  params.forEach(function (value, key) {
    objUrlParams[key] = value;
  });

  var sortPairs = Object.keys(objUrlParams).
  filter(function (key) {return key.includes('SortAscending') || key.includes('SortField');}).
  reduce(function (obj, key) {
    return Object.assign(obj, _defineProperty({},
    key, objUrlParams[key]));

  }, {});

  var sortString = new URLSearchParams(sortPairs).toString();
  var paramString = '&' + sortString;
  if (sortString.length < 1) {
    paramString = '';
  }

  function getArticleSearchValue() {
    if (!elArticleSearchInput || !elArticleSearchInput.value) return '';
    return 'query=' + elArticleSearchInput.value + '&';
  }

  function getFilterTags() {
    if (!arrFilterCheckboxes) return '';
    var objCheckedFilterValues = {};
    var lastCategory = '';

    function addNewCategory(currentCategory) {
      if (lastCategory !== currentCategory) {
        lastCategory = currentCategory;
        objCheckedFilterValues[lastCategory] = [];
      }
    }

    for (var i = 0; i < arrFilterCheckboxes.length; i++) {
      if (arrFilterCheckboxes[i].checked === true) {
        var currentCategory = arrFilterCheckboxes[i].getAttribute('data-js');
        //if category is missing skip input altogether
        if (currentCategory) {
          addNewCategory(currentCategory);
          objCheckedFilterValues[lastCategory].push(arrFilterCheckboxes[i].name);
        }
      }
    }

    var arrCategories = Object.keys(objCheckedFilterValues);
    if (arrCategories.length < 1) {
      // nothing valid is checked return nothing
      return '';
    }

    var queryString = '';
    for (var j = 0; j < arrCategories.length; j++) {
      var category = arrCategories[j];
      queryString += '&' + category + '=' + objCheckedFilterValues[category].join(urlDelimiter);
    }
    return queryString;
  }

  function resetFilters() {
    for (var i = 0; i < arrFilterCheckboxes.length; i++) {
      arrFilterCheckboxes[i].removeAttribute('checked');
      arrFilterCheckboxes[i].checked = false;
    }
  }

  function handlerResetForm(e) {
    elArticleSearchForm && resetFilters();
  }

  function handlerSubmitFilters(e) {
    e.preventDefault();
    var url = baseUrl + '?' + (getArticleSearchValue() + getFilterTags() + paramString);
    window.location = url;
  }

  function init() {
    if (elArticleFilterForm) {
      elArticleFilterForm.addEventListener('reset', handlerResetForm);
      elArticleFilterForm.addEventListener('submit', handlerSubmitFilters);
    }
    if (elArticleSearchForm) {
      elArticleSearchForm.addEventListener('submit', handlerSubmitFilters);
    }
  }

  init();
})();